import "devextreme/ui/select_box";
import "devextreme/ui/check_box";
import "devextreme/ui/switch";
import "devextreme/ui/number_box";
import "devextreme/ui/text_box";
import "devextreme/ui/date_box";
import "devextreme/ui/tag_box";
import "devextreme/ui/text_area";

import { lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App.tsx";
import "devextreme/dist/css/dx.light.css";
import "leaflet/dist/leaflet.css";
import "react-leaflet-cluster/dist/assets/MarkerCluster.css";
import "react-leaflet-cluster/dist/assets/MarkerCluster.Default.css";
import "./index.css";
import config from "devextreme/core/config";
import { licenseKey } from "./devextreme-license";
import "@fontsource/dm-sans/400.css"; // Specify weight
import "@fontsource/dm-sans/400-italic.css";
import { setUnauthorizedHandler } from "@/services/api";
import { useAuthStore } from "@/contexts/useAuthStore";
import { initializeLocalization } from "./localization/devextreme-italian.ts";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const ReactQueryDevtools = import.meta.env.DEV
  ? lazy(() =>
    import("@tanstack/react-query-devtools").then((module) => ({
      default: module.ReactQueryDevtools,
    })),
  )
  : null;

// Configure DevExtreme
config({ licenseKey });

// Initialize Italian localization
initializeLocalization();

// Wire global 401 handler once at startup without causing circular imports
setUnauthorizedHandler(() => {
  // Access the store outside React by calling the hook function directly
  const { setUser } = useAuthStore.getState();
  setUser();
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <App />
      {ReactQueryDevtools ? (
        <Suspense fallback={null}>
          <ReactQueryDevtools initialIsOpen={false} />
        </Suspense>
      ) : null}
    </QueryClientProvider>
  </BrowserRouter>
);
